import React from 'react';
import './InitialChoice.css';

function InitialChoice({ onSelectOption, closeModal, designGalleryUrl }) {
  const trackAndSelect = choice => {
    // Track in Google Analytics
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'initial_choice_selected', {
        event_category: 'engagement',
        event_label: choice,
      });
    }
    onSelectOption(choice);
  };

  const handleShowDesigns = () => {
    trackAndSelect('utees_design');

    // Persist orderType synchronously before redirect since the normal
    // localStorage save is debounced and won't complete before navigation
    // Note: OrderWizard uses 'formData' key, not 'quoteFormData'
    try {
      var existingData = localStorage.getItem('formData');
      var storedFormData = existingData ? JSON.parse(existingData) : {};
      storedFormData.orderType = 'utees_design';
      localStorage.setItem('formData', JSON.stringify(storedFormData));
    } catch (e) {
      // Ignore localStorage errors
    }

    closeModal();
    // Redirect to design gallery
    window.location.href = designGalleryUrl || '/designs';
  };

  const handleOwnArtwork = () => {
    trackAndSelect('own_artwork');
  };

  const handleContactMe = () => {
    trackAndSelect('contact_only');
  };

  return (
    <div className="initial-choice">
      <div>
        <h2 className="heading-cofo c-heading c-heading-2 centered mvn">
          How would you like to get started?
        </h2>
        <p className="mts mbl centered">
          Choose the option that best fits your needs.
        </p>
      </div>

      <div className="initial-choice-options">
        <button
          type="button"
          className="initial-choice-option"
          onClick={handleShowDesigns}
        >
          <div className="initial-choice-option-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 19l7-7 3 3-7 7-3-3z"></path>
              <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path>
              <path d="M2 2l7.586 7.586"></path>
              <circle cx="11" cy="11" r="2"></circle>
            </svg>
          </div>
          <h3 className="initial-choice-option-title">
            Show me designs to customize
          </h3>
          <p className="initial-choice-option-description">
            Browse our design gallery and customize it to fit your vision.
          </p>
        </button>

        <button
          type="button"
          className="initial-choice-option"
          onClick={handleOwnArtwork}
        >
          <div className="initial-choice-option-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
          </div>
          <h3 className="initial-choice-option-title">I have my own artwork</h3>
          <p className="initial-choice-option-description">
            Upload your design files and we'll bring them to life.
          </p>
        </button>

        <button
          type="button"
          className="initial-choice-option"
          onClick={handleContactMe}
        >
          <div className="initial-choice-option-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <h3 className="initial-choice-option-title">
            I'm not sure yet, have someone contact me
          </h3>
          <p className="initial-choice-option-description">
            Share your details and our team will reach out to help.
          </p>
        </button>
      </div>
    </div>
  );
}

export default InitialChoice;
